"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PHOTO_CAROUSEL_SLIDE_POSITIONS = void 0;
var PHOTO_CAROUSEL_SLIDE_POSITIONS = Object.freeze({
  LEFT: 'left',
  CENTER: 'center',
  RIGHT: 'right'
});
exports.PHOTO_CAROUSEL_SLIDE_POSITIONS = PHOTO_CAROUSEL_SLIDE_POSITIONS;